import React, { type ReactNode } from "react";
import { tuple } from "../_util/type";

// export const ButtonSize = tuple("small", "middle", "large");
export const ButtonSize = tuple("sm", "md", "lg");

export interface InputBoxProps extends React.HTMLAttributes<HTMLInputElement> {
  // 大小
  size?: typeof ButtonSize[number];
  className?: string;
  innerClassName?: string;
  value?: string;
  children?: ReactNode;
  onSearchChange?: (value: string) => void;
}
